import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography
} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import 'modules/cap/styles/cap.css'

import { setAuthenticatedRoleStatus as setAuthenticatedRoleStatusSlice } from 'stores/modules/idp/authreducer';

const RoleDescriptionPage = () => {
  // Redux dispatch
  const dispatch = useDispatch();

  // Redux selectors
  const authenticatedRoleStatusContainer = useSelector(state => state.auth.authenticatedRoleStatus);
  const authenticatedUserContainer = useSelector(state => state.auth.user);

  // State variables
  const [show, setShow] = useState(false);
  const [loggeduser, setloggeduser] = useState(null);
  
  // useEffect hook sets the role of logged in user
  useEffect(() => {
    if (authenticatedRoleStatusContainer && authenticatedUserContainer) {
      const user = authenticatedUserContainer.roles[0].slug;
      setloggeduser(user);
      setShow(true);
    } else {
      setShow(false);
      setloggeduser(null);
    }
  }, [authenticatedRoleStatusContainer, authenticatedUserContainer]);
  
  // Handles closing of role description page
  function closing() {
    setShow(false);
    dispatch(setAuthenticatedRoleStatusSlice(null));
  }

  return (
    <div>
      <Dialog
        onClose={closing}
        open={show}
        PaperProps={{
          style: {
            borderRadius: 50
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, background: '#0E0A65', color: 'white', textAlign: 'center' }}>
          {loggeduser === "admin" && (
            <div className="text-h4">You are now logged in as Company Admin</div>
          )}
          {loggeduser === "superuser" && (
            <div className="text-h4">You are now logged in as super user</div>
          )}
          {loggeduser === "user" && (
            <div className="text-h4">You are now logged in as user</div>
          )}
        </DialogTitle>
        <DialogContent>
          <Typography>
            <div className='audit-trail-popuptext'>
              {loggeduser === 'admin' && (
                <div className='role-description-page'>
                  <div className="col">
                    <p className="py-2"><b className="text-black" >The Company Admin user role enables you to perform the following tasks:</b></p>
                  </div>
                  <div className="col">
                    <p> <ArrowRightIcon className="text-black" /> <span className="pl-2 text-black">Create User(s) for your Company.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /><span className="pl-2 text-black">Onboard a Child Company(s) under your Company.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /><span className="pl-2 text-black">Edit, Delete a Child Company(s) under your Company.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /><span className="pl-2 text-black">Add Users for a Child Company(s).</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /><span className="pl-2 text-black">Assign Assessments to Users of your Company & Child Company(s) under your Company.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /> <span className="pl-2 text-black">Review, Approve, Reject Assessments of your Company & Child Company(s) under your Company.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /> <span className="pl-2 text-black"> View Assessments, Dashboard of your Company & Child Company(s) under your Company.</span><br /></p>
                  </div>
                </div>
              )}
              {loggeduser === 'superuser' && (
                <div className='role-description-page'>
                  <div className="col">
                    <p className="py-2"><b className="text-black">The super user role enables you to perform the following tasks:</b></p>
                  </div>
                  <ul className="custom-list">
                    <li className="text-black"><span className="arrow"></span> Assign assessments to users of your company & child company(s) under your company.</li>
                    <li className="text-black"><span className="arrow"></span> Review, approve, reject assessments of your company & child company(s) under your company.</li>
                    <li className="text-black"><span className="arrow"></span> Assign, review, reject mitigation plan for assessments for your company child company(s) under your company.</li>
                    <li className="text-black"><span className="arrow"></span> View assessments, dashboard of your company & child Company(s) under your company.</li>
                  </ul>
                </div>
              )}
              {loggeduser === 'user' && (
                <div className='role-description-page'>
                  <div className="col">
                    <p className="py-2"><b className="text-black" >The user role enables you to perform the following tasks:</b></p>
                  </div>
                  <div className="col">
                    <p> <ArrowRightIcon className="text-black" /> <span className="pl-2 text-black">Can submit assessments.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /><span className="pl-2 text-black">Can upload evidence,remarks for mitigation plans.</span><br /></p>
                    <p><ArrowRightIcon className="text-black" /><span className="pl-2 text-black">Can view assessments,dashboard.</span><br /></p>
                  </div>
                </div>
              )}
            </div>
          </Typography>
        </DialogContent>
        <DialogActions className='justify-center'>
          <Button variant="contained" onClick={closing}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default RoleDescriptionPage;
